import axios from 'axios'
// TODO сделать кастомный снекбар для уведомления юзера + сделать снекбар с ошибками с кастомным текстом
async function makeRequest({commit}, {method, path, params, headers,responseType, data, description, snackbar, successInfo, infoTimeout}) {
  if(snackbar)
    commit('snackbar/SET_LOADING_SNACKBAR', {text: description}, {root: true})
  const response = await axios({
    method: method,
    url: path,
    headers: headers,
    responseType: responseType,
    params: params,
    data: data,
    onUploadProgress: (progressEvent) => {
      if(snackbar){
        let uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        commit('snackbar/UPDATE_LOADING_PERCENTAGE', uploadPercentage, {root: true})
      }
    }
  }).catch(e => {
    if(snackbar){
      commit('snackbar/CLOSE_SNACKBAR', 'loading', {root: true})
    }
    let errorData = {...e, description: description}
    commit('snackbar/SET_REPORT_SNACKBAR', {errorData: errorData, timeout: null}, {root: true})

    throw e
    //return e.response;
  });
  if(snackbar){
    commit('snackbar/CLOSE_SNACKBAR', 'loading', {root: true})
    if(successInfo){
      commit('snackbar/SET_INFO_SNACKBAR', {text: successInfo, timeout: infoTimeout ?? 5000}, {root: true})
    }
  }
  return response;
}

// Аргументы у функций:
// -method: Метод запроса
// path: Путь к запросу, добавляется к url
// headers: Заголовки запросы
// params: Параметры запроса
// data: Payload запроса
// description: Описание запроса
// snackbar: Флаг, используется снекбар или нет
// successInfo: Отображаемый в случае успеха текст
// infoTimeout: Время отображения текста в случае успеха (дефолт 5000 мс)
export default {
  async POST({commit, rootState}, args) {
    args.method = 'post'
    return makeRequest({commit, rootState}, args)
  },

  async PATCH({commit, rootState}, args) {
    args.method = 'patch'
    return makeRequest({commit, rootState}, args)
  },

  async GET({commit, rootState}, args) {
    args.method = 'get'
    return makeRequest({commit, rootState}, args)
  },

  async PUT({commit, rootState}, args) {
    args.method = 'put'
    return makeRequest({commit, rootState}, args)
  },

  async DELETE({commit, rootState}, args) {
    args.method = 'delete'
    return makeRequest({commit, rootState}, args)
  }
}
